<div class="flex flex-col gap-4">
  <app-src-settings-activation></app-src-settings-activation>

  <app-src-settings-algorithms></app-src-settings-algorithms>
</div>
